import getPageName from "./getPageName";
import getPageType from "../common/getPageType";

const itemsTypeCustomerItems = state => ({
  ...state,
  globals: {
    ...state.globals,
    attributionCategory: getPageType(),
    pageName: getPageName(),
    pageType: getPageType()
  }
});

export default itemsTypeCustomerItems;
